import { gql } from "@apollo/client";

export const GET_INDICACION_APROBACION_INSUMO_BYID = gql`
  query getIndicacionAprobacionInsumoById($idIndicacionAprobacion: Int!) {
    indicacionAprobacionInsumoById(idIndicacionAprobacion: $idIndicacionAprobacion) {
      success
      error
      valorEsperado {
        idIndicacionInsumo
        idIndicacion
        idInsumoN
        insumo
        cantidad
        idUnidad
        unidad
      }
    }
  }
`;